var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 9.66683H12.333V1.66683C12.333 1.31321 12.1925 0.974069 11.9425 0.724021C11.6924 0.473972 11.3533 0.333496 10.9997 0.333496C10.6461 0.333496 10.3069 0.473972 10.0569 0.724021C9.80682 0.974069 9.66634 1.31321 9.66634 1.66683V9.66683H1.66634C1.31272 9.66683 0.973581 9.80731 0.723532 10.0574C0.473484 10.3074 0.333008 10.6465 0.333008 11.0002C0.333008 11.3538 0.473484 11.6929 0.723532 11.943C0.973581 12.193 1.31272 12.3335 1.66634 12.3335H9.66634V20.3335C9.66634 20.6871 9.80682 21.0263 10.0569 21.2763C10.3069 21.5264 10.6461 21.6668 10.9997 21.6668C11.3533 21.6668 11.6924 21.5264 11.9425 21.2763C12.1925 21.0263 12.333 20.6871 12.333 20.3335V12.3335H20.333C20.6866 12.3335 21.0258 12.193 21.2758 11.943C21.5259 11.6929 21.6663 11.3538 21.6663 11.0002C21.6663 10.6465 21.5259 10.3074 21.2758 10.0574C21.0258 9.80731 20.6866 9.66683 20.333 9.66683Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.8177ff6e6994736a7b566c6924d84f5e.svg";
export { ForwardRef as ReactComponent };